<mat-chip-listbox [value]="activeLang()" (change)="onLangChange($event)">
  @for (lang of langs; track lang) {
    <mat-chip-option [value]="lang">
      {{ lang.toUpperCase() }}
      @if (controlFor(lang).invalid && controlFor(lang).touched) {
        <span class="text-red-500 ml-0.5">*</span>
      }
    </mat-chip-option>
  }
</mat-chip-listbox>
<mat-form-field class="w-full mt-3">
  <mat-label>{{ activeLang().toUpperCase() }}</mat-label>
  <textarea matInput [formControl]="activeControl()" rows="6"></textarea>
  <mat-error>{{ 'generic.required' | translate }}</mat-error>
</mat-form-field>
